import { render, staticRenderFns } from "./BasePanelBox.vue?vue&type=template&id=88512fe2&scoped=true"
import script from "./BasePanelBox.vue?vue&type=script&lang=js"
export * from "./BasePanelBox.vue?vue&type=script&lang=js"
import style0 from "./BasePanelBox.vue?vue&type=style&index=0&id=88512fe2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88512fe2",
  null
  
)

export default component.exports